"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

const isSchema = obj => obj && obj.__isYupSchema__;

var _default = isSchema;
exports.default = _default;